import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ModuleDataMilestoneService {
  private apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}module-data-milestones`;
  }

  /**
   * Get available milestone templates for a specific module ID
   */
  getAvailableTemplates(
    moduleId: number,
    search: string = '',
  ): Observable<any> {
    const url = `${this.apiUrl}/templates/${moduleId}`;
    if (search) {
      return this.http.get(url, { params: { search } });
    }
    return this.http.get(url);
  }

  /**
   * Smart Suggestions: milestones (from any template of this module) whose own conditions
   * currently match the record and that aren't already attached. Bid & Job only; the backend
   * returns an empty list for any other module.
   */
  getSmartSuggestions(moduleId: number, dataId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/smart-suggestions/${moduleId}/${dataId}`);
  }

  /**
   * Attach selected milestones to a module
   */
  attachMilestones(data: {
    module_id: number;
    data_id: number;
    milestones: any[];
  }): Observable<any> {
    return this.http.post(`${this.apiUrl}/attach`, data);
  }

  /**
   * Auto-deploy the module's auto-deploy milestone template (if configured) onto a
   * newly created record. Silent no-op on the backend when no template is enabled.
   */
  autoDeploy(moduleId: number, dataId: number): Observable<any> {
    // Must be POST — the backend route is Route::post('auto-deploy', …). Using PUT
    // makes it fall through to PUT {id} (updateMilestoneData) with id="auto-deploy",
    // causing a TypeError (int $id expected).
    return this.http.post(`${this.apiUrl}/auto-deploy`, {
      module_id: moduleId,
      data_id: dataId,
    });
  }

  /**
   * Remove a specific milestone from a module
   */
  detachMilestone(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
